import React from 'react';
import Cookies from 'js-cookie';
import './Home.sass';

function Home() {
    const [state, setState] = React.useState(false);

    window.addEventListener('message', (event) => {
        if(event.data.type === 'onboardingStarted') {
            setState(true);
            document.body.style.overflow = 'hidden';
        }
    });

    return (
        <div className="homeArea">
            <div className="homeAreaTop">
                <iframe
                    src={`${process.env.REACT_APP_FENIX_HOST}onboarding?language=${Cookies.get('currentLanguage')}`}
                    allowTransparency="true"
                    style={{
                        width: '100%',
                        border: 'none',
                        height: !state ? 'calc(100vh - 90px)' : '100vh',
                        ...state && {
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            zIndex: 999999999
                        }
                    }}
                ></iframe>
            </div>
        </div>
    );
}

export default Home;
